export class PersonIncomeDetailModel{

    public IncomeSourceLkp:number;
    public MonthlyIncomeAmount:number;
    constructor(){
        
    }
}